webpackJsonp(["plugin--focus-element"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus/plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global $:true */
/*
Set Focus

Focus another element on a valid jquery event. By default this is `click`.


### Html Attributes

```
  data-focus-element
  data-focus-element--on="valid jquery event name"
  data-focus-element--target="[(scoping-directive)] .valid-jquery > selector"
  data-focus-element--delegate="true|false, bind event on element, or on document root"
  data-focus-element--ignore-child-events="true|false, child triggers events"
```

Markup:
<div class="u-align u-align--horizontal u-align--vertical-space-between" style="width: 20rem; height: 20rem;">
  <a class="u-focus u-focus--blue-light"
     href="#"
     id="GlobalJavascriptSetFocus">Focus target</a>
  <button
    data-focus-element
    data-focus-element--on="click"
    data-focus-element--target="#GlobalJavascriptSetFocus">A button</button>
</a>

Styleguide Global.Javascript.SetFocus
*/


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'plugins/focus-element';
var log = (0, _debug2.default)(MODULE_NAME);

log('registerd');

var PluginKlass = function () {
  function PluginKlass(element, options) {
    _classCallCheck(this, PluginKlass);

    log('new instance', element, options);

    this.element = element;
    this.options = options;

    this.$element = (0, _jquery2.default)(element);

    this.watch();

    log('ready', this.$element);
  }

  _createClass(PluginKlass, [{
    key: 'watch',
    value: function watch() {
      var _options = this.options,
          on = _options.on,
          target = _options.target,
          delegate = _options.delegate;

      if (on === '(now)') {
        this.focusTarget();
      } else if (!delegate) {
        this.boundEvent = this.$element.on(on, this.filterNonDelegateEvents(this.focusTarget));
      } else {
        (0, _jquery2.default)(document).on(on, this.element, this.filterNonDelegateEvents(this.focusTarget));
      }
      log('watching', this.element, { on: on, target: target, delegate: delegate });
    }
  }, {
    key: 'filterNonDelegateEvents',
    value: function filterNonDelegateEvents(fn) {
      var _this = this;

      var ignoreChildEvents = this.options.ignoreChildEvents;

      return function (event) {
        if (ignoreChildEvents && event.target !== _this.element) {
          return;
        } else {
          fn.call(_this);
        }
      };
    }
  }, {
    key: 'focusTarget',
    value: function focusTarget() {
      log('change');
      if (!this.options.target) {
        log('WARNING! missing focus-element `target` for ', this.$element);
      }
      var $target = this.selectors.selectTarget(this.options.target, this.$element);

      if (this.options.ifTarget && !$target.is(this.options.ifTarget)) {
        return;
      }

      log('change.targeting', $target);
      this.$element.trigger(_index.PLUGIN_NAME + '.source');
      $target.focus();
      $target.trigger(_index.PLUGIN_NAME + '.target');
    }
  }]);

  return PluginKlass;
}();

PluginKlass.DEFAULTS = {
  on: 'click',
  if: null, // conditional selector state of element
  ifTarget: null, // conditional selector state of target
  target: null,
  delegate: false, // bind on element or use delegate events on document.
  ignoreChildEvents: false // whether or not child events trigger
};

(0, _lib2.default)(_index.PLUGIN_NAME, PluginKlass);

/***/ })

});


// WEBPACK FOOTER //
// scripts/plugin--focus-element--9412f582db3e9bb88edc.js